/* import React, { useState, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Input, Select, Radio } from '../../Components/Form/Form';
import Button from 'react-bootstrap/esm/Button';
import { useSelector } from 'react-redux';
*/
import React from 'react'
import ReporteRed from '../Report/ReporteRed';
const Red = () => {
    return <ReporteRed isAdmin={false} />
}

/* const Red = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [reporte, setReport] = useState({})
    const jwt = useSelector(store => store.session.jwt)

    const [data, setData] = useState({
        p_id_state: 1,
        p_point_min: '',
        p_point_max: '',
        p_type: 'COMISIONES'
    })

    const [states] = useState([
        { name_state: 'Todos', id_state: -1 },
        { name_state: 'Activo', id_state: 1 },
        { name_state: 'De Baja', id_state: 0 },
    ])

    const cboState = useCallback(() => {
        let findState = states.find(w => parseInt(w.id_state) === parseInt(data.p_id_state))

        if (!findState) {
            return ''
        }

        return {
            label: findState.name_state,
            value: findState.id_state
        }
    }, [states, data.p_id_state])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                {
                    name: 'id_customers', text: 'ID', align: 'center'
                },
                { name: 'id_upline', text: 'Upline', align: 'center', },
                { name: 'id_sponsor', text: 'Sponsor', align: 'center', },
                { name: 'full_name', text: 'Nombres', },
                { name: 'nivel', text: 'Nivel', align: 'center', },
                { name: 'name_plan', text: 'Rango', align: 'center', },
                { name: 'date_registration', text: 'Fecha de Ingreso', align: 'center', },
                { name: 'point_current_customers', text: 'Puntos', align: 'center', render: r => {
                    return <div className={'badge badge-' + (parseInt(r.point_current_customers) >= Helpers.config.pointMinRange ? 'success' : (parseInt(r.point_current_customers) > 0 ? 'warning' : 'danger') )}>
                        {r.point_current_customers}
                    </div>
                } },
                { name: 'point_business_customers', text: 'Valor Negocio', align: 'center', },
                {
                    name: 'id_status', text: 'Estatus', align: 'center', render: r => <div className={'badge badge-' + (parseInt(r.id_status) === 1 ? 'success' : 'danger')}>
                        {parseInt(r.id_status) === 1 ? 'Activo' : 'De Baja'}
                    </div>
                },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center', },
                { name: 'code_country', text: 'País', align: 'center', },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Descendencia de Red</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} onSubmit={_ => {
                    setIsProccesing(true)
                    setRows([]);
                    setReport({})
                    Controllers.red.get_my_red({
                        p_id_state: data.p_id_state === -1 ? '' : data.p_id_state,
                        p_point_min: data.p_point_min,
                        p_point_max: data.p_point_max,
                        p_type: data.p_type,
                    }).then(res => {
                        setRows(res.data.rows)
                        setReport({
                            excel: res.data.excel.file,
                            filename: res.data.excel.filename,
                        })
                    }).catch(req => Helpers.promise.catch({ req, toast }))
                        .finally(() => {
                            setIsProccesing(false)
                        })
                }}>
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="fa fa-user"
                        text="Estado"
                        required
                        onChange={e => {
                            setData({ ...data, p_id_state: e.value })
                            setRows([]);
                            setReport({})
                        }}
                        value={cboState()}
                        options={states.map(w => {
                            return {
                                label: w.name_state,
                                value: w.id_state
                            }
                        })}
                    />
                    <Input
                        classNameParent="col-6 mb-2"
                        icon="fa fa-user"
                        placeholder="Puntos Mínimos"
                        text="Puntos Mínimos"
                        type="number"
                        value={data.p_point_min}
                        onChange={e => {
                            setData({ ...data, p_point_min: e.currentTarget.value })
                            setRows([])
                            setReport({})
                        }}
                        required={data.p_point_min !== ''}
                    />
                    <Input
                        classNameParent="col-6 mb-2"
                        icon="fa fa-user"
                        placeholder="Puntos Máximos"
                        text="Puntos Máximos"
                        type="number"
                        value={data.p_point_max}
                        onChange={e => {
                            setData({ ...data, p_point_max: e.currentTarget.value })
                            setRows([])
                            setReport({})
                        }}
                        required={data.p_point_max !== ''}
                        append={[
                            <Button type="submit">
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                    <div className="col-12">
                        <div className="d-flex">
                            <Radio
                                id="rdb-fechas"
                                classNameParent="mr-3 mb-2"
                                text="Comisiones"
                                checked={data.p_type === 'COMISIONES'}
                                onChange={e => {
                                    setData({ ...data, p_type:  'COMISIONES' })
                                    setReport({})
                                    setRows([])
                                }}
                            />
                            <Radio
                                id="rdb-periodo"
                                classNameParent=""
                                text="Colocación"
                                checked={data.p_type === 'ROLL_OVER'}
                                onChange={e => {
                                    setData({ ...data, p_type:  'ROLL_OVER' })
                                    setReport({})
                                    setRows([])
                                }}
                            />
                        </div>
                    </div>
                </FormCustom>
                {reporte?.filename ? <div className='mb-4'>
                    <a href={reporte?.excel} download={reporte?.filename} className="mr-2">
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                    {data.p_type === 'ROLL_OVER' && <a href={Helpers.config.apiUrl({
                        url: '/red/order/red-roll-over/?jwt=' + jwt
                    })} target="_blank" rel='noreferrer'>
                        <Button size="sm" variant="dark">
                            <i className="fa fa-file-excel mr-2"></i>Ver Descendencia Ordenada
                        </Button>
                    </a>}
                    {data.p_type === 'COMISIONES' && <a href={Helpers.config.apiUrl({
                        url: '/red/order/red/?jwt=' + jwt
                    })} target="_blank" rel='noreferrer'>
                        <Button size="sm" variant="dark">
                            <i className="fa fa-file-excel mr-2"></i>Ver Descendencia Ordenada
                        </Button>
                    </a>}
                </div> : ''}
                {dtRows}
            </Card.Body>
        </Card>
    </>
} */

export default Red